<template>
  <w-sliding-popup :type="showSettingView ? 'setting' : ''" ref="slidingPopup" :title="title" width="850px" @close="close()">
    <div slot="content">
      <el-row class="title-bar" type="flex" :style="'justify-content:' + (taskData.params ? 'space-between;' : 'flex-end;')">
        <el-button v-if="taskData.params" size="small" type="secondary" @click="onStopModelingBtn">모델링 강제종료</el-button>
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </el-row>
      <el-table-wrapper ref="resultTable" max-height="500" :column-default="columnDefault" :data="tableData" :columns="tableColumns" remote pagination :total="total"
      :show-search-tool="showSearchTool" :show-custom-header="true" @condition-change="onConditionChange">
        <template #request-type-icmp-slot="scope">
          <el-checkbox disabled :value="scope.row.icmpReply" true-label="1" false-label="0" />
        </template>
        <template #request-type-snmp-slot="scope">
          <el-checkbox disabled :value="scope.row.snmpReply" true-label="1" false-label="0" />
        </template>
      </el-table-wrapper>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" @click="close">닫기</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil } from 'lodash';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import DeviceRegistrationNmsAPI from '@/api/settings/common/device-registration-nms';
import msgUtil from '@/utils/message';

export default {
  name: 'WModelingResultPopup',
  data() {
    return {
      scheduleData: {},
      columnDefault,
      total: 0,
      showSearchTool: false,
      tableData: [],
      taskData: {},
      tableColumns: [
        { prop: 'icmpReply', label: 'ICMP 모델링', width: 100, scopedSlot: 'request-type-icmp-slot' },
        { prop: 'snmpReply', label: 'SNMP 모델링', width: 100, scopedSlot: 'request-type-snmp-slot' },
        { prop: 'objName', label: '장비명', searchable: true, sortable: true, remoteProp: 'nas.obj_name' },
        { prop: 'scanAddress', label: 'IP', searchable: true, sortable: true, remoteProp: 'nas.scan_address' },
        { prop: 'objCompanyName', label: '제조사', searchable: true, sortable: true, formatter: this.getValueAfterCheckEmpty, remoteProp: 'oc.obj_company_name' },
        { prop: 'objProductId', label: '모델', searchable: true, sortable: true, formatter: this.getValueAfterCheckEmpty, remoteProp: 'nas.obj_product_id' },
        { prop: 'checkDatetime', label: '확인 시각', width: 150, searchable: true, sortable: true, searchType: 'date', formatter: this.getDateFormatter, remoteProp: 'nas.check_datetime' },
      ],
    };
  },
  computed: {
    /**
     * 팝업 타이틀 - 스케줄 이름 정보가 있을 경우 타이틀에 함께 표시하도록
     * @author Song
     */
    title() {
      const targetName = this.scheduleData.scheduleId ? `[${this.scheduleData.scheduleName}]` : '';
      return `${targetName} 모델링 결과`;
    },
    /**
     * 팝업 화면 조정 - 액션 프로그래스를 통해 팝업을 볼 경우 현재 보는 화면이 세팅 or 메인 화면 크기에 따라 팝업 type을 변경할 수 있도록
     * @author Song
     */
    ...mapGetters(['showSettingView']),
  },
  methods: {
    /**
     * 네트워크 모델링 결과를 조회한다.
     * @author Song
     */
    loadData(data) {
      let apiParams = {};
      const tableParams = this.$refs.resultTable.getParameter();
      if (data.scheduleId) {
        this.scheduleData = data;
        apiParams = {
          scheduleId: data.scheduleId,
          ...tableParams,
        };
      } else if (data.params) {
        this.taskData = data;
        apiParams = {
          scanIds: data.params.scanIds,
          ...tableParams,
        };
      }
      DeviceRegistrationNmsAPI.getNetdeviceModelingResultList(apiParams).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.data;
          this.total = res.data.total;
        }
      });
    },
    open(row) {
      this.$refs.slidingPopup.visible = true;
      this.$nextTick(() => {
        this.loadData(row);
      });
    },
    close() {
      this.showSearchTool = false;
      this.scheduleData = {};
      this.taskData = {};
      this.$refs.resultTable.clearFilter();
      this.$refs.slidingPopup.visible = false;
    },
    /**
     * 날짜를 지정한 포맷으로 변환한다.
     * @author Song
     */
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    getValueAfterCheckEmpty(row, colum, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 네트워크 모델링 (프로그래스 아이콘 > 팝업 > 강제종료 [테스크 강제종료])
     * @author Song
     */
    onStopModelingBtn() {
      // 테스트 강제종료 시 complete 요청을 먼저 요청하고 completeAction 함수를 사용하여 액션 프로그래스를 지워준다.
      this.taskData.complete();
      this.taskData.completeAction();
      this.$message(msgUtil.getResultMsgData('취소', '네트워크 모델링', true));
      this.close();
    },
    onConditionChange() {
      const targetData = this.scheduleData.scheduleId ? this.scheduleData : this.taskData;
      this.loadData(targetData);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Network/popup/ModelingResultPopup.vue